import React from "react";

const CustomSwitch = ({ checked, onChange, disabled }) => {
  const switchStyles = {
    width: "40px",
    height: "20px",
    borderRadius: "12px",
    backgroundColor: checked ? "#06513D" : "#d9d9d9",
    display: "flex",
    alignItems: "center",
    justifyContent: checked ? "flex-end" : "flex-start",
    padding: "1px",
    cursor: disabled ? "not-allowed" : "pointer",
    position: "relative",
    transition: "all 0.3s ease",
    opacity: disabled ? 0.7 : 1,
    border: "none",
    outline: "none",
  };

  const toggleStyles = {
    width: "16px",
    height: "16px",
    backgroundColor: "#fff",
    borderRadius: "50%",
    position: "relative",
    transition: "all 0.3s ease",
  };

  const crossStyles = {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    color: "#fff",
    fontSize: "16px",
    visibility: checked ? "visible" : "hidden",
  };

  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      style={switchStyles}
      disabled={disabled}
      onClick={handleToggle}
      aria-label="Toggle switch"
    >
      {disabled && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "16px",
            height: "16px",
            border: "2px solid #f3f3f3",
            borderTop: "2px solid #0087A3",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
      )}
      <span style={crossStyles}>×</span>
      {!disabled && <div style={toggleStyles}></div>}
    </button>
  );
};

export default CustomSwitch;
